import {
  enumeratedLiterals,
  type EnumeratedLiteralType,
} from "./enumeratedLiterals";

export const AccountingModes = enumeratedLiterals(
  ["accrual", "cash"] as const,
  {
    getLabels: (accessors) =>
      ({
        [accessors.ACCRUAL]: "Accrual Performance",
        [accessors.CASH]: "Cash snapshot",
      } as const),
  },
);

export type AccountingMode = EnumeratedLiteralType<typeof AccountingModes>;
